/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails
 */
export interface FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails {
    /**
     * 
     */
    status_set_date?: string;
    /**
     * 
     */
    status_set_reason?: string;
}

/**
 * Check if a given object implements the FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails interface.
 */
export function instanceOfFindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails(value: object): value is FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails {
    return true;
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetailsFromJSON(json: any): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails {
    return FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetailsFromJSONTyped(json, false);
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'status_set_date': json['status_set_date'] == null ? undefined : json['status_set_date'],
        'status_set_reason': json['status_set_reason'] == null ? undefined : json['status_set_reason'],
    };
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetailsToJSON(json: any): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails {
    return FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetailsToJSONTyped(json, false);
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetailsToJSONTyped(value?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status_set_date': value['status_set_date'],
        'status_set_reason': value['status_set_reason'],
    };
}

